import { useState } from "react";
import { Save, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../api";

const FIELDS = [
  ["short_name", "Kısa ad", true], ["name", "Şirket ünvanı", true], ["specialty", "Uzmanlık", false, "sub"],
  ["contact_person", "Yetkili kişi"], ["phone", "Telefon"], ["email", "E-posta"],
  ["tax_office", "Vergi dairesi"], ["tax_no", "Vergi / TC no"], ["iban", "IBAN"],
];

export default function EntityEditModal({ kind, item, close, onSaved }) {
  const isSub = kind === "subcontractor";
  const path = isSub ? "/subcontractors" : "/employers";
  const label = isSub ? "Alt yüklenici" : "İşveren";
  const [form, setForm] = useState(() => Object.fromEntries([...FIELDS.map(([k]) => k), "address", "notes"].map((k) => [k, item?.[k] || ""])));
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    const payload = Object.fromEntries(Object.entries(form).map(([k, v]) => [k, v === "" ? null : v]));
    try {
      if (item?.id) await api.put(`${path}/${item.id}`, payload); else await api.post(path, payload);
      toast.success(item?.id ? `${label} güncellendi` : `${label} eklendi`);
      onSaved(); close();
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div className="modal-backdrop" onClick={close}>
      <form className="modal modal-wide" onClick={(e) => e.stopPropagation()} onSubmit={submit} data-testid={`${kind}-edit-modal`}>
        <div className="modal-head">
          <div><span className="eyebrow">{item?.id ? "KAYDI DÜZENLE" : "YENİ KAYIT"}</span><h2>{item?.id ? item.short_name : `Yeni ${label}`}</h2></div>
          <button type="button" onClick={close} data-testid="entity-modal-close"><X size={18} /></button>
        </div>
        <div className="form-grid three">
          {FIELDS.filter(([, , , only]) => !only || (only === "sub" && isSub)).map(([k, l, req]) => (
            <label key={k}>{l}<input required={!!req} value={form[k]} onChange={set(k)} data-testid={`entity-${k}-input`} /></label>
          ))}
        </div>
        <label>Adres<input value={form.address} onChange={set("address")} data-testid="entity-address-input" /></label>
        <label>Fatura / şirket notları<textarea rows={2} value={form.notes} onChange={set("notes")} data-testid="entity-notes-input" /></label>
        <button className="new-btn full" data-testid="entity-save-button"><Save size={15} /> {item?.id ? "Güncelle" : "Kaydet"}</button>
      </form>
    </div>
  );
}
